import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';

export default function VerbMenuItem({ activeHref, activeKey, children, ...props }) {
    return (
        <Dropdown.Item active={false} {...props}>
            {children}
        </Dropdown.Item>
    );
}

VerbMenuItem.propTypes = {
    activeHref: PropTypes.string,
    activeKey: PropTypes.any,
    children: PropTypes.any
};
